package com.karyadina.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import com.karyadina.model.ThemeMode

// Define your brand colors
private val PrimaryLight = Color(0xFF006C4C)
private val SecondaryLight = Color(0xFF4C6358)
private val TertiaryLight = Color(0xFF3E6373)

private val PrimaryDark = Color(0xFF89D8B6)
private val SecondaryDark = Color(0xFFB3CCBE)
private val TertiaryDark = Color(0xFFA6CCE0)

private val LightColorScheme = lightColorScheme(
    primary = PrimaryLight,
    secondary = SecondaryLight,
    tertiary = TertiaryLight
)

private val DarkColorScheme = darkColorScheme(
    primary = PrimaryDark,
    secondary = SecondaryDark,
    tertiary = TertiaryDark
)


@Composable
fun AppTheme(
    mode: ThemeMode = ThemeMode.SYSTEM,
    seedColor: Color? = null,
    content: @Composable () -> Unit
) {
    val systemDark = isSystemInDarkTheme()
    val useDarkTheme = when (mode) {
        ThemeMode.LIGHT -> false
        ThemeMode.DARK -> true
        ThemeMode.SYSTEM -> systemDark
    }

    val baseScheme = if (useDarkTheme) DarkColorScheme else LightColorScheme
    
    val colorScheme = if (seedColor != null) {
        // Robust generation to avoid "white box" issues and ensure contrast
        if (useDarkTheme) {
            baseScheme.copy(
                primary = seedColor,
                onPrimary = Color.Black, // Dark text on bright primary usually reads better, or White if primary is dark. Assuming vibrant seed.
                primaryContainer = seedColor.copy(alpha = 0.3f), // Transparent container for depth
                onPrimaryContainer = seedColor.copy(alpha = 0.9f),
                secondary = seedColor.copy(alpha = 0.7f),
                onSecondary = Color.Black,
                tertiary = seedColor.copy(alpha = 0.5f),
                // Ensure surfaces are dark
                surface = Color(0xFF121212),
                surfaceVariant = seedColor.copy(alpha = 0.1f), // Tinted surface for cards/boxes
                onSurfaceVariant = Color.LightGray
            )
        } else {
            baseScheme.copy(
                primary = seedColor,
                onPrimary = Color.White,
                primaryContainer = seedColor.copy(alpha = 0.15f), // Light tint
                onPrimaryContainer = seedColor.copy(alpha = 1f), // Strong text
                secondary = seedColor.copy(alpha = 0.8f),
                tertiary = seedColor.copy(alpha = 0.6f),
                // Ensure surfaces are light/white
                surface = Color.White,
                surfaceVariant = seedColor.copy(alpha = 0.05f), // Very subtle tint
                onSurfaceVariant = Color.DarkGray
            )
        }
    } else {
        baseScheme
    }

    MaterialTheme(
        colorScheme = colorScheme,
        // typography = Typography, // Add Typography later
        content = content
    )
}